(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["roi-calculator"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('roi-calculator-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // Here we would add the calculator logic
    // For now, just show the success message for demonstration
    this.parentNode.querySelector('.w-form-done').style.display = 'block';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-navbar-scroll"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $(window).on('scroll', function() {
      var scrollPosition = $(window).scrollTop();
      $('div[id]').each(function() {
        var sectionTop = $(this).offset().top;
        var sectionHeight = $(this).outerHeight();
        var sectionId = $(this).attr('id');
        var navbarLink = $('a.navdown[href="#' + sectionId + '"]');

        if (scrollPosition >= sectionTop - 100 && scrollPosition < sectionTop + sectionHeight - 100) {
          navbarLink.addClass('active');
        } else {
          navbarLink.removeClass('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
